import type { Dayjs } from 'dayjs';

export type AttemptTimeRangeDraft = [Dayjs | null, Dayjs | null] | null;

const HOURS_PER_DAY = 24;
const MINUTES_PER_HOUR = 60;
const HOURS = Array.from({ length: HOURS_PER_DAY }, (_, hour) => hour);
const MINUTES = Array.from({ length: MINUTES_PER_HOUR }, (_, minute) => minute);

const getMinuteOfDay = (value: Dayjs) =>
  value.hour() * MINUTES_PER_HOUR + value.minute();

export const isAttemptTimeRangeValid = (attemptFrom: Dayjs, attemptTo: Dayjs) =>
  getMinuteOfDay(attemptTo) > getMinuteOfDay(attemptFrom);

export const normalizeAttemptTimeRangeDraft = (
  value: AttemptTimeRangeDraft,
): AttemptTimeRangeDraft => {
  const attemptFrom = value?.[0];
  const attemptTo = value?.[1];

  if (
    attemptFrom &&
    attemptTo &&
    !isAttemptTimeRangeValid(attemptFrom, attemptTo)
  ) {
    return [attemptFrom, null];
  }

  return value;
};

export const getAttemptTimeDisabledOptions = (
  _date: Dayjs,
  range: 'start' | 'end',
  info: { from?: Dayjs },
) => {
  if (range !== 'end' || !info.from) {
    return {};
  }

  const startHour = info.from.hour();
  const startMinute = info.from.minute();
  const disabledHourCount =
    startMinute === MINUTES_PER_HOUR - 1 ? startHour + 1 : startHour;

  return {
    disabledHours: () => HOURS.slice(0, disabledHourCount),
    disabledMinutes: (hour: number) => {
      if (hour < startHour) {
        return [...MINUTES];
      }

      if (hour === startHour) {
        return MINUTES.slice(0, startMinute + 1);
      }

      return [];
    },
  };
};
